module.exports = __webpack_public_path__ + "static/media/allie20.8fd7d6d0.jpg";